import React, { useState, useEffect } from "react";
import { supabase } from "./supabaseClient";
import "./UnitSlideShow.css";

function UnitSlideShow({ unitId }) {
  const [slides, setSlides] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSlides = async () => {
      const { data, error } = await supabase
        .from("unit_slides")
        .select("*")
        .eq("unit_id", unitId)
        .order("created_at", { ascending: true });

      if (error) {
        console.error("Slaytlar yüklenirken hata oluştu:", error);
      } else {
        setSlides(data || []);
      }
      setLoading(false);
    };

    fetchSlides();
  }, [unitId]);

  if (loading) return <p>Yükleniyor...</p>;
  if (!slides.length) return <p></p>;

  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === slides.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? slides.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className="unit-slideshow-wrapper">
      <div className="unit-slideshow">
        <div
          className="slides"
          style={{ transform: `translateX(-${currentIndex * 100}%)` }}
        >
          {slides.map((slide) => (
            <div key={slide.id} className="slide">
              <img
                src={slide.img_url}
                alt={`Slide ${slide.id}`}
                className="slide-image"
              />
            </div>
          ))}
        </div>
        <button className="slide-button prev" onClick={prevSlide}>
          ◀
        </button>
        <button className="slide-button next" onClick={nextSlide}>
          ▶
        </button>
      </div>
    </div>
  );
}

export default UnitSlideShow;
